/**
 * context/ThemeContext.jsx
 *
 * Manages dark/light mode globally.
 * Extracted from App.jsx so SettingsTab can toggle the theme without prop drilling.
 */

import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext({
  dark: true,
  toggleDark: () => {},
});

export function ThemeProvider({ children }) {
  const [dark, setDark] = useState(() => {
    try { return localStorage.getItem('tt-theme') !== 'light'; } catch { return true; }
  });

  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark);
    try { localStorage.setItem('tt-theme', dark ? 'dark' : 'light'); } catch {}
  }, [dark]);

  return (
    <ThemeContext.Provider value={{ dark, toggleDark: () => setDark(d => !d) }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
